// src/pages/user/PaymentSuccess.jsx

import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f5f5f5"
    >
      <Paper sx={{ p: 4, textAlign: "center", maxWidth: 400 }}>
        <Typography variant="h4" gutterBottom>
          Payment Successful!
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Thank you for your payment. Your project is now active.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/user", { replace: true })}
        >
          Go to Dashboard
        </Button>
      </Paper>
    </Box>
  );
}
